import React from 'react'
import UserPageDiscover from '../../components/UserPageDiscover/UserPageDiscover'
import Footer from '../../common/Footer/Footer'
import UserPage from '../../common/UserPage/UserPage'
import { getCurrentUser } from '../../redux/userSlice';


const UserPageDiscoverPage = () => {
  return (
    <div>
    <UserPage customImage={getCurrentUser?.picture} />
      <UserPageDiscover />
      <Footer />
    </div>
  )
}

export default UserPageDiscoverPage
